/**
 * Created by lycheng on 2017/12/4.
 */
import 'scss/services/offline_tts.scss'
import 'babel-polyfill'
import { player } from 'js/libs/jplayer/init-audio'
import { floatMenu } from 'js/libs/utils-float-menu'
import { layer } from 'js/libs/utils-layer'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import { config } from 'config'
import { getQueryString } from 'js/libs/utils'

serviceQA()
serviceTopbar()

$(function () {
  let businessId = 'xtts'
  $('.service-navigator-items li').click(function () {
    let $this = $(this)
    let $navigator = $('.service-navigator-items')
    let $oldActiveWrapDOM = $('.service-item-price-wrap').find('.service-item-active')
    let $activeWrapDOM = $(`.${$this.data('nav')}`)
    $this.siblings('li.service-active').removeClass('service-active')
    $this.addClass('service-active')
    $oldActiveWrapDOM.removeClass('service-item-active')
    $activeWrapDOM.addClass('service-item-active')
    // 为了保持页面操作统一 ----- 公共滚动都是绑定到service-item-voice，要保证页面中只有一个是可见的
    $oldActiveWrapDOM.find('.service-item-price-new').removeClass('service-item-price')
    $oldActiveWrapDOM.find('.service-item-voice-new').removeClass('service-item-voice')
    $activeWrapDOM.find('.service-item-price-new').addClass('service-item-price')
    $activeWrapDOM.find('.service-item-voice-new').addClass('service-item-voice')
    businessId = $this.data('businessId')
    if (businessId === 'aisound') {
      $('.item-platform-windows').show()
    } else {
      // xtts 的平台只有windows android ios
      $('.item-platform-windows').hide()
    }
  })
  if (getQueryString('service') === 'xtts') {
    $('.service-nav-high-quality').trigger('click')
  } else if (getQueryString('service') === 'aisound') {
    $('.service-nav-common').trigger('click')
  }
  if (getQueryString('target') === 'voice') {
    $('html,body').animate({
      scrollTop: $('.service-item-active .service-item-voice').offset().top - 100
    }, 1e3)
  }
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).attr('package-id')
    let wareId = $(this).attr('ware-id')
    let params = {
      wareId: wareId,
      packageId: packageId,
      serviceName: businessId === 'aisound' ? '离线语音合成（普通版）' : '离线语音合成（高品质版）',
      businessId: businessId
    }
    goServiceBuy(params)
  })
  $('.watch-voice').click(function () {
    floatMenu.methods.toPosition('service-item-voice')
  })
  $('.service-item-voice-new .voice-scene-wrap').on('click', '.voice-scene', function () {
    $('.service-item-voice-new .voice-scene').removeClass('active')
    $(this).addClass('active')
    $('.service-item-voice-new .voice-table table').removeClass('table-active')
    $('.' + $(this).attr('id')).addClass('table-active')
  })
  $('.service-item-voice-new .better-voice-scene-wrap').on('click', '.better-voice-scene', function () {
    $('.service-item-voice-new .better-voice-scene').removeClass('better-active')
    $(this).addClass('better-active')
    $('.service-item-voice-new .better-voice-table table').removeClass('better-table-active')
    $('.' + $(this).attr('id')).addClass('better-table-active')
  })
  $('.voice-table, .better-voice-table').on('click', '.voice-play', function () {
    if ($(this).hasClass('voice-pause')) {
      player.pause()
    } else {
      var url = $(this).data('playUrl')
      var $this = $(this)
      player.buttonClick(url, null, function () {
        $('.voice-play').removeClass('voice-pause').attr('title', '试听')
        $this.addClass('voice-pause').attr('title', '暂停')
      }, function () {
        $this.removeClass('voice-pause').attr('title', '试听')
      })
    }
  }).on('click', '.to-buy-tts', function () {
    layer.open('.modal-wrapper-offline-buy')
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/offline_tts.js